import apiService from "./api";
import { EpointBalance, MonthlyStats } from "../types/epoints";
import securityConfig from "../config/security";

function getIdFromToken(): string | null {
  try {
    const token = localStorage.getItem(securityConfig.TOKEN_STORAGE_KEY);
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.dealerId || payload?.userId || payload?.sub || null;
  } catch {
    return null;
  }
}

export class EpointsApiService {
  async getBalance(): Promise<EpointBalance> {
    const id = getIdFromToken();
    if (!id) throw new Error("Missing identity in token");

    const response = await apiService.get<any>("/transaction/dealer/balance");
    const payload = response?.data?.payload || response?.payload;
    if (payload?.balance === undefined) {
      throw new Error("Invalid balance response structure");
    }

    const balance = Number(payload.balance);
    return {
      customerId: id,
      customerDisplayId: id,
      availablePoints: Math.floor(balance * 100),
      totalPoints: Math.floor(balance * 100),
      pendingPoints: 0,
      redeemedPoints: 0,
      totalCashValue: balance,
      availableCashValue: balance,
      pendingCashValue: 0,
      redeemedCashValue: 0,
      currency: "EUR",
      lastTransactionDate: undefined,
      lastRedemptionDate: undefined,
    };
  }

  async getMonthlyStats(): Promise<MonthlyStats> {
    const response = await apiService.get<{ data: MonthlyStats }>(
      "/epoints/monthly-stats",
    );
    return response.data;
  }

  async getPointsHistory(params?: {
    page?: number;
    limit?: number;
    type?: "earned" | "redeemed" | "all";
    startDate?: string;
    endDate?: string;
  }) {
    const response = await apiService.get<{
      data: {
        transactions: Array<{
          _id: string;
          type: "earned" | "redeemed";
          amount: number;
          description: string;
          createdAt: string;
          source?: string;
        }>;
        total: number;
        page: number;
        totalPages: number;
      };
    }>("/epoints/history", params);
    return response.data;
  }
}

export const epointsApi = new EpointsApiService();
export default epointsApi;
